// extracted by css-extract-rspack-plugin
export default {"result":"_cf32f0fe","searchResultIcon":"_c2ee3bb"};